import Vuex from 'vuex'

export default new Vuex.Store({
  state: {
    pathData: []
  },
  mutations: {
    setPathData (state, newPathData) {
      state.pathData = newPathData
    },
    addCheckpoint (state, checkpoint) {
      state.pathData.push(checkpoint)
    }
  },
  actions: {
    savePathData ({ commit }, newPathData) {
      commit('setPathData', newPathData)
      localStorage.setItem('pathData', JSON.stringify(newPathData))
    },
    addPathCheckpoint ({ commit, state }, checkpoint) {
      const newPathData = [...state.pathData, checkpoint]
      commit('addCheckpoint', checkpoint)
      localStorage.setItem('pathData', JSON.stringify(newPathData))
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/module/visitas/index.js